import * as Api from '../API';

const config: Api.Configuration = { basePath: process.env.REACT_APP_API_URL };

//** Selfcare Customer apis */
export const CustomerApi = new Api.SelfcareCustomerApi(config);

//**  Calendar product api */
export const CalendarApi = new Api.CalendarApi(config);
